import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ButtonGroup from './buttonGroup.vue';
import DropDownMenu from './dropDownMenu/dropDownMenu';
import Btn from '@/gikam/js/components/button/vue/button.vue';
import Gikam from 'gikam';
export default {
  props: {
    options: Object,
    window: Object
  },
  components: {
    ButtonGroup: ButtonGroup,
    Btn: Btn,
    DropDownMenu: DropDownMenu
  },
  data: function data() {
    return {
      //默认更多按钮宽度
      defaultMoreWidth: 95,
      showMoreBtn: false,
      moreBtnOptions: {
        icon: 'btn-more',
        text: this.$i18n('workspace.moreMenu'),
        fragment: null,
        items: []
      },
      fillWidth: null
    };
  },
  mounted: function mounted() {
    this.onResize();
  },
  methods: {
    // eslint-disable-next-line complexity
    onResize: function onResize() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var width, $toolbar, i, children, $, allBtnsWidth, othersCompWidth, btns, _i, item, fragment, items, _i2, _item;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$nextTick();

              case 2:
                width = _this.$el.offsetWidth;

                if (!(width === _this.fillWidth)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                $toolbar = _this.$refs['btn-wrapper'];
                _this.showMoreBtn = false;

                if (_this.moreBtnOptions.fragment) {
                  for (i = _this.moreBtnOptions.fragment.length; i > 0; i--) {
                    $toolbar.appendChild(_this.moreBtnOptions.fragment[i - 1]);
                  }

                  _this.updateOrder($toolbar);

                  _this.moreBtnOptions.fragment = null;
                }

                children = $toolbar.children;

                if (!(children.length < 3)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return");

              case 11:
                $ = Gikam.jQuery;
                allBtnsWidth = 0;
                othersCompWidth = 0;
                btns = [];

                for (_i = 0; _i < children.length; _i++) {
                  item = children[_i];

                  if (['button', 'dropDownMenu'].includes(item.getAttribute('type')) && $(item).outerWidth(true)) {
                    btns.push(item);
                    allBtnsWidth += $(item).outerWidth(true);
                  } else {
                    othersCompWidth += $(item).outerWidth(true);
                  }
                }

                if (!(allBtnsWidth + othersCompWidth - width <= 0)) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return");

              case 18:
                fragment = document.createDocumentFragment();
                items = [];
                _i2 = btns.length - 1;

              case 21:
                if (!(_i2 >= 0)) {
                  _context.next = 31;
                  break;
                }

                _item = btns[_i2];
                fragment.appendChild(_item);
                items.unshift(_this.options.items[_item.getAttribute('index')]);
                allBtnsWidth -= $(btns[_i2 - 1]).outerWidth(true);

                if (!(allBtnsWidth + othersCompWidth + _this.defaultMoreWidth < width)) {
                  _context.next = 28;
                  break;
                }

                return _context.abrupt("break", 31);

              case 28:
                _i2--;
                _context.next = 21;
                break;

              case 31:
                _this.moreBtnOptions.fragment = [].slice.call(fragment.childNodes);
                _this.moreBtnOptions.items = items;
                _this.fillWidth = width;
                _this.showMoreBtn = true;
                _context.next = 37;
                return _this.$nextTick();

              case 37:
                _this.defaultMoreWidth = $(_this.$refs['btn-more']).outerWidth(true);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 更新toolbar顺序
    updateOrder: function updateOrder(dom) {
      var fragment = document.createDocumentFragment();
      var toolbars = Array.from(dom.children).sort(function (prev, cur) {
        return prev.getAttribute('index') - cur.getAttribute('index');
      });
      toolbars.forEach(function (item) {
        return fragment.appendChild(item);
      });
      dom.appendChild(fragment);
    },
    hiddenChangehandler: function hiddenChangehandler() {
      this.onResize();
    }
  }
};